import React from 'react';
import PropTypes from 'prop-types';
import { sendEcommerceEvent } from '../../../components/GA4';

const defaultProps = {
  title: Drupal.t('roomName missing'),
};

const TravelSearchResult = (properties) => {
  const props = {
    ...defaultProps,
    ...properties,
  };

  const dataLayer = window.dataLayer;

  const handleBooking = () => {
    sendEcommerceEvent(
      dataLayer,
      'select_item',
      false,
      props.title,
      props.price,
      props.departmentName,
      props.housingType,
      props.companyName
    );
  };
  const url = new URL(props.bookingLink);
  if (props.external) {
    url.searchParams.set('source', 'travelsearch');
  }
  const bookingButton = (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      onClick={() => handleBooking()}
      href={url.toString()}
      className={`button button--large-full-width ${
        props.external ? 'external-link' : ''
      } `}
      target={props.external ? '_blank' : ''}
      rel={props.external ? 'noopener' : ''}
    >
      {props.linkText ??
        Drupal.t('Book', {}, { context: 'Accommodation search' })}
    </a>
  );

  const compressedResult = (
    <div className="accommodation-search__result">
      <div className="accommodation-search__result__header">
        <div>
          <h4 className="accommodation-search__result__header--name">
            {props.title}
          </h4>

          {props.price && (
            <h4 className="accommodation-search__result__header--price">
              {' '}
              {props.price} €{' '}
            </h4>
          )}

          {props.numberOfResults && (
            <div className="accommodation-search__result__header--locations">
              {props.numberOfResults} {Drupal.t('locations')}
            </div>
          )}
        </div>
        <div className="accommodation-search__result__compressed-body">
          {props.beds && (
            <span>
              {props.beds} {Drupal.t('beds')}
            </span>
          )}
          {props.custBody && props.custBody}
        </div>
      </div>
      <div className="accommodation-search__result__button-wrapper">
        {bookingButton}
      </div>
    </div>
  );

  const searchResult = (
    <div className="accommodation-search__result">
      <div className="accommodation-search__result__image-wrapper">
        {props.image.url && (
          <img
            src={props.image.url}
            alt={props.image.description}
            width={390}
            height={260}
          />
        )}
      </div>
      <div className="accommodation-search__result__content-wrapper">
        <div className="accommodation-search__result__header">
          <div>
            <h4>{props.title}</h4>
          </div>
          <div className="accommodation-search__result__price">
            {props.price ? `${props.price} €` : ''}
            {props.numberOfResults
              ? `${props.numberOfResults} ${Drupal.t('locations')}`
              : ''}
          </div>
        </div>
        {props.additionalInfo && (
          <div className="accommodation-search__result__additional-info">
            {props.additionalInfo}
          </div>
        )}
        {props.custBody && (
          <div className="accommodation-search__result__combined-accommodations">
            {props.custBody}
          </div>
        )}
        <div className="accommodation-search__result__specs-wrapper">
          <ul className="accommodation-search__result__specs-list">
            {props.area ? (
              <li>
                {props.area}m²
                {props.housingType ? `, ${[props.housingType[0].Text]}` : null}
              </li>
            ) : null}
            {props.beds ? (
              <li>
                {props.beds} {Drupal.t('beds')}
              </li>
            ) : null}
          </ul>
          <ul className="accommodation-search__result__specs-list">
            {props.lift_distance || props.lift_distance === 0 ? (
              <li>
                {props.lift_distance} km {Drupal.t('to lift')}
              </li>
            ) : null}
            {props.skitrail_distance || props.skitrail_distance === 0 ? (
              <li>
                {props.skitrail_distance} km {Drupal.t('to trail')}
              </li>
            ) : null}
            {props.village_distance || props.village_distance === 0 ? (
              <li>
                {props.village_distance} km {Drupal.t('to village')}
              </li>
            ) : null}
          </ul>
        </div>
        {bookingButton}
      </div>
    </div>
  );

  if (!props.alwaysShow && props.numberOfResults === 0 && !props.price) {
    return <></>;
  }

  if (props.isCompressed) {
    return compressedResult;
  } else {
    return searchResult;
  }
};

TravelSearchResult.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object,
  area: PropTypes.number,
  beds: PropTypes.string,
  village_distance: PropTypes.number,
  lift_distance: PropTypes.number,
  skitrail_distance: PropTypes.number,
  price: PropTypes.string,
  custBody: PropTypes.element,
  numberOfResults: PropTypes.number,
  bookingLink: PropTypes.string,
  external: PropTypes.bool,
  linkText: PropTypes.string,
  additionalInfo: PropTypes.string,
  departmentName: PropTypes.string,
  housingType: PropTypes.array,
  alwaysShow: PropTypes.bool,
  isCompressed: PropTypes.bool,
  companyName: PropTypes.string,
};

export default TravelSearchResult;
